/**
 * Attaches the stored session token to every request made by an axios instance.
 *
 * Kept in one place so that every API client the app talks to sends the
 * credential the same way, and so the storage key is defined once.
 */
const attachAuthToken = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("jwtToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

export default attachAuthToken;
